import React, { useEffect, useState } from "react";
import { fetchFormData } from "../../utils/options";
import { useNavigate } from "react-router-dom";
import topTost from "../../utils/topTost";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { BsWindowSidebar } from "react-icons/bs";
import Footer from "../shared/Footer";
const ResetForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    old_password: "",
    new_password: "",
    confirm_password: "",
  });
  const [showPassword, setShowPassword] = useState({
    old: false,
    new: false,
    confirm: false,
  });

  useEffect(()=>{
  window.scrollTo(0,0)
  if(!localStorage.getItem("access_token"))navigate("/")
  },[])
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const id = localStorage.getItem("id");
const handleSubmit = async (e) => {
  e.preventDefault();

  // Frontend validation
  if (formData.new_password !== formData.confirm_password) {
    topTost({
      title: "New Password and Confirm Password must match",
    icon: "error",
    });
    return;
  }

  try {
    const form = new FormData();
    form.append("old_password", formData.old_password);
    form.append("new_password", formData.new_password);

    // fetchFormData returns ONLY data.result
    const result = await fetchFormData(`change-password/${id}`, form, "POST");

    if (result?.status === "true") {
      topTost({ title: result?.message, icon: "success" });

      setTimeout(() => {
        navigate("/home");
        window.location.reload();
      }, 600);
    } else {
      topTost({
        title: result?.message || "Invalid Old Password",
       icon: "error",
      });
    }

  } catch (error) {
    topTost({
      title: "Something went wrong!",
icon: "error",
    });
  }
};

  const togglePassword = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };
  return (
    <>
      <h2 className="fs-20 fw-bolder mb-4">Reset</h2>
      <h4 className="fs-13 fw-bold mb-2">Reset your password</h4>
      <p className="fs-12 fw-medium text-muted">
        Enter your old and new password to reset your account.
      </p>

      <form className="w-100 mt-4 pt-2" onSubmit={handleSubmit}>
        <div className="mb-3 position-relative">
          <input
            type={showPassword.old ? "text" : "password"}
            name="old_password"
            className="form-control mb-3"
            placeholder="Enter Old Password"
            value={formData.old_password}
            onChange={handleChange}
            required
          />
          <span
            className="position-absolute top-50 end-0 translate-middle-y me-3 text-muted"
            style={{ cursor: "pointer" }}
            onClick={() => togglePassword("old")}
          >
            {showPassword.old ? <FiEye /> : <FiEyeOff />}
          </span>{" "}
        </div>
        <div className="mb-3 position-relative">
          <input
            type={showPassword.new ? "text" : "password"}
            name="new_password"
            className="form-control"
            placeholder="Enter New Password"
            value={formData.new_password}
            onChange={handleChange}
            required
          />
          <span
            className="position-absolute top-50 end-0 translate-middle-y me-3 text-muted"
            style={{ cursor: "pointer" }}
            onClick={() => togglePassword("new")}
          >
            {" "}
            {showPassword.new ? <FiEye /> : <FiEyeOff />}
          </span>
        </div>
        {/* CONFIRM PASSWORD (Only frontend) */}
        <div className="mb-3 position-relative">
          <input
            type={showPassword.confirm ? "text" : "password"}
            name="confirm_password"
            className="form-control"
            placeholder="Confirm New Password"
            value={formData.confirm_password}
            onChange={handleChange}
            required
          />
          <span
            className="position-absolute top-50 end-0 translate-middle-y me-3 text-muted"
            style={{ cursor: "pointer" }}
            onClick={() => togglePassword("confirm")}
          >
            {showPassword.confirm ? <FiEye /> : <FiEyeOff />}
          </span>
        </div>
        <div className="mt-5">
          <button type="submit" className="btn btn-lg btn-primary w-100">
            Reset Now
          </button>
        </div>
      </form>
    
    </>
  );
};

export default ResetForm;
